import { render } from "./CardsEventos.vue?vue&type=template&id=b66266c0&scoped=true"
import script from "./CardsEventos.vue?vue&type=script&lang=js"
export * from "./CardsEventos.vue?vue&type=script&lang=js"

import "./CardsEventos.vue?vue&type=style&index=0&id=b66266c0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b66266c0"]])

export default __exports__